import React from "react";
import { Dialog, DialogPanel, Transition } from "@headlessui/react";
import ModalCore from "./core/modalCore";
export function Modal({ open, setOpen, title, children, clickOut = true, widthClass }) {
    return (<>
            <Transition appear show={open}>
                <Dialog as="div" className="relative z-30" 
    // onClose fires for both Escape and outside-click; clickOut=false instead wraps the overlay in a DialogPanel below.
    onClose={() => setOpen(false)}>
                    {!clickOut ? (<DialogPanel>
                            <ModalCore title={title} setOpen={setOpen} children={children} widthClass={widthClass}/>
                        </DialogPanel>) : (<ModalCore title={title} setOpen={setOpen} children={children} widthClass={widthClass}/>)}
                </Dialog>
            </Transition>
        </>);
}
//# sourceMappingURL=modal.jsx.map